import { PrismicTextProps } from "../types/PrismicTextProps";

export function isPrismicTextPropValid(textProp: PrismicTextProps) {
    return textProp[0].text.length > 0;
}
